<template>
  <o-dialog
    ref="dialog"
    :title="$t('general.cancel')"
    :info="$t('components.waitlist.actions.cancel.info')"
    :options="[
      { text: $t('general.back'), type: 'cancel' },
      { text: $t('components.waitlist.actions.cancel.confirm'), type: 'confirm', callback: confirm, variant: 'warning' },
    ]"
    :portal="portal"
  />
</template>

<script setup lang="ts">
import type { Waitlist } from '~/_api/models/waitlist'

interface Props {
  portal?: string | null
  loading?: boolean
}

interface Emits {
  (e: 'update:loading', value: boolean): void
  (e: 'update:waitlist', value: Waitlist): void
  (e: 'success'): void
}

withDefaults(defineProps<Props>(), {
  portal: null,
  loading: false,
})

const emit = defineEmits<Emits>()
const { $api, $i18n, $notification, $bus } = useNuxtApp()

const dialog = ref<any>()
const waitlist = ref<Waitlist | null>(null)

const open = (item: Waitlist) => {
  waitlist.value = item

  dialog.value.open()
}

const confirm = async () => {
  emit('update:loading', true)

  try {
    const response = await $api.waitlist.cancel(waitlist.value!)

    if (response.data) {
      emit('update:loading', false)
      emit('update:waitlist', response.data)
      emit('success')

      $bus.emit.updated('Waitlist', response.data)

      $notification.toast({
        title: $i18n.t('general.cancelled'),
        text: $i18n.t('components.waitlist.actions.cancel.successInfo'),
        variant: 'success',
      })

      return true
    }
  } catch (e: any) {
    console.log(e)
  }
}

defineExpose({ open })
</script>
